module.exports = __webpack_public_path__ + "img/f41.03f075d8.jpg";